import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { State } from '../../State';
import { getContractParticipantsFetched } from '../../State/selectors/mdqx/selectors';
import { GetContractParticipantsRequest } from '../../State/actions/mdqx/contract-participant.actions';

@Injectable({
    providedIn: 'root',
})
export class ContractParticipantResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getContractParticipantsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetContractParticipantsRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
